import React, {useEffect} from "react";
import MathJax from 'react-mathjax-preview';
import TeX from '@matejmazur/react-katex';
import './AnalizaMain.css';
import {useHistory} from "react-router-dom";
import * as BiIcons from "react-icons/bi";


export default function Calki(){

	useEffect(()=>{
		document.title="Całki";
	},[])

	const { push } = useHistory();

	const comeBackFunc=()=>{
		push('/analiza');
	}

	return(
		<div className='conceptsContainer'>
			<div className='comeBackDiv' onClick={comeBackFunc}>
				<BiIcons.BiArrowBack/>
				<div style={{textAlign: 'left', alignItems: 'left'}}>Cofnij</div>
			</div>

			<h1>Całki</h1>
			<p>Całkowanie to działanie odwrotne do różniczkowania.</p>
			<p>Całką funkcji <TeX math={'f(x)'}/> możemy nazwać funkcję <TeX math={'F(x)'}/>, taką że:</p>
			<p><MathJax math={'`F\'(x)=f(x)`'}/></p>
			<p>Jeśli powyższy warunek jest spełniony to funkcja F(x) jest funkcją pierwotną.</p>
			<br/>
			<p>Całkowanie zapisujemy:</p>
			<p><MathJax math={'`intf(x)dx=F(x)`'}/></p>
			<h5><TeX math={'dx'}/>&nbsp;oznacza, że całkujemy funkcję <TeX math={'f(x)'}/>&nbsp;po zmiennej x.</h5>
			<br/>

			<p>Przykład:</p>
			<p className='oneLine centerVertical'>1)&nbsp;&nbsp;<MathJax math={'`intf(x)dx&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
			'f(x)=6x+20`'}/></p>
			<p className='oneLine centerVertical'><MathJax math={'`int 6x+20&nbsp;dx=3x^2+20x+z`'}/>, gdzie&nbsp;<TeX math={'z'}/>
				&nbsp;- dow. liczba rzeczywista.</p>
			<p className='oneLine centerVertical'>2)&nbsp;&nbsp;<MathJax math={'`intf(x)dx&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
			'f(x)=x^7`'}/></p>
			<p className='oneLine centerVertical'><MathJax math={'`int x^7&nbsp;dx=1/8x^8+z`'}/>, gdzie&nbsp;<TeX math={'z'}/>
				&nbsp;- dow. liczba rzeczywista.</p>
			<br/>

			<div className='tabelaWzory'>
				<h2>Podstawowe wzory rachunku całkowego</h2>
				<br/>
				<p className='oneLine centerVertical'>1)&nbsp;&nbsp;<MathJax math={'`a=0`'}/>&nbsp;&nbsp;to&nbsp;&nbsp;
					<MathJax math={'`int dx=x+z`'}/> </p>
				<p className='oneLine centerVertical'>2)&nbsp;&nbsp;<MathJax math={'`a=-1/2`'}/>&nbsp;&nbsp;to&nbsp;&nbsp;
					<MathJax math={'`int dx/sqrt(x)=2sqrt(x)+z`'}/>, gdzie&nbsp;<TeX math={'x'}/>&#62;0</p>
				<p className='oneLine centerVertical'>3)&nbsp;&nbsp;<MathJax math={'`a=-2`'}/>&nbsp;&nbsp;to&nbsp;&nbsp;
					<MathJax math={'`int dx/x^2=-1/x+z`'}/>, gdzie&nbsp;<TeX math={'x'}/>&#8800;0</p>
				<p className='oneLine centerVertical'>4)&nbsp;&nbsp;<MathJax math={'`int dx/x=ln|x|+z`'}/>,
					gdzie&nbsp;<TeX math={'x'}/>&#8800;0</p>
				<p className='oneLine centerVertical'>5)&nbsp;&nbsp;<MathJax math={'`int k&nbsp;dx=kx+z`'}/></p>
				<p className='oneLine centerVertical'>6)&nbsp;&nbsp;<MathJax math={'`int e^x&nbsp;dx=e^x+z`'}/></p>
				<p className='oneLine centerVertical'>7)&nbsp;&nbsp;<MathJax math={'`int a^x&nbsp;dx=a^x/lna+z`'}/>,
					gdzie&nbsp;<TeX math={'a'}/>&#62;0, <TeX math={'a'}/>&#8800;1</p>
				<p className='oneLine centerVertical'>8)&nbsp;&nbsp;<MathJax math={'`int cosx&nbsp;dx=sinx+z`'}/></p>
				<p className='oneLine centerVertical'>9)&nbsp;&nbsp;<MathJax math={'`int sinx&nbsp;dx=-cosx+z`'}/></p>
				<p className='oneLine centerVertical'>10)&nbsp;&nbsp;<MathJax math={'`int (dx)/cos^2x&nbsp;dx=tgx+z`'}/>,
					gdzie&nbsp;<TeX math={'cosx'}/>&#8800;0</p>
				<p className='oneLine centerVertical'>11)&nbsp;&nbsp;<MathJax math={'`int (dx)/sin^2x&nbsp;dx=-ctgx+z`'}/>,
					gdzie&nbsp;<TeX math={'sinx'}/>&#8800;0</p>
				<p className='oneLine centerVertical'>12)&nbsp;&nbsp;<MathJax math={'`int (dx)/(sqrt(1-x^2))&nbsp;dx=arcsinx+z`'}/>,
					gdzie&nbsp;-1&#60;<TeX math={'x'}/>&#60;1</p>
				<p className='oneLine centerVertical'>13)&nbsp;&nbsp;<MathJax math={'`int (dx)/(x^2+1)&nbsp;dx=arctgx+z`'}/>,
					gdzie&nbsp;-1&#60;<TeX math={'x'}/>&#60;1</p>
			</div>
		</div>
	);
}